import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ContenuPosePushTutosNotices } from '@components/contenu-pose-push-tutos-notices/models';
import { ButtonComponent } from '@shared/components/button';
import { CardTitleTextHtmlComponent } from '@shared/components/card-title-text-html';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { LinkDirective } from '@shared/directives';

@Component({
  selector: 'app-contenu-pose-push-tutos-notices',
  imports: [
    CardTitleTextHtmlComponent,
    TitleComponent,
    ImageComponent,
    ButtonComponent,
    LinkDirective,
    NgTemplateOutlet,
    SvgComponent,
  ],
  templateUrl: './contenu-pose-push-tutos-notices.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContenuPosePushTutosNoticesComponent extends AbstractDynamicComponent<ContenuPosePushTutosNotices> {}
